export default {
  inject: {
    additionalQuote: {
      default: false,
    },
  },
  computed: {
    quoteNamespace() {
      return this.additionalQuote ? 'additionalQuote' : 'quote'
    },
  },
}
